<template>
  <div>
    <base-header type="gradient-primary" class="pb-6 pb-8 pt-5 pt-md-8"/>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="card mb-3">

            <div class="row header-cont">
              <div class="col-md-9">
                <h2 style="margin: 0;">Admin Users</h2>
              </div>

              <div class="col-md-3 btn-cont">
                <button class="btn btn-sm btn-default float-right" @click.prevent="actionPromotion({}, 'create')">
                  + Add Admin User
                </button>
              </div>
            </div>

            <div class="col-md-12 cont">
              <a-table
                size="small"
                :columns="tableColumns"
                :dataSource="admins"
                :rowKey="(record) => record.id"
                :scroll="{ x: 1300 }">

                <template slot="action" slot-scope="action">
                  <div class="table-button-container">
                    <button
                      class="btn btn-sm btn-warning"
                      @click.prevent="actionPromotion(action, 'edit')"
                    >
                      Edit
                    </button>
                    <!-- <button
                      class="btn btn-sm btn-danger"
                      @click.prevent="actionPromotion(action, 'delete')"
                    >
                      Delete
                    </button> -->
                  </div>
                </template>
              </a-table>
            </div>

            <admin-user-form
              :action='userFormAction'
              :user='selectedUser'
              :showDrawer='showUserForm'
              @closeDrawer='closeAdminUserForm'
              @success='userFormSuccess'/>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest.js';
import { mapState } from 'vuex';
import secureStorage from '../../controllers/secureStorage';
import AdminUserForm from './Drawers/AdminUserForm.vue';

export default {
  data() {
    return {
      admins: [],
      selectedUser: {},
      showUserForm: false,
      userFormAction: 'create',
      tableColumns: [
        {
          title: "User ID",
          width: 250,
          dataIndex: "id",
          key: "id",
        },
        {
          title: "Name",
          width: 250,
          dataIndex: "name",
          key: "name",
        },
        {
          title: "Status",
          width: 250,
          dataIndex: "status",
          key: "status",
        },
        {
          title: "Actions",
          key: "action",
          fixed: "right",
          width: 200,
          scopedSlots: { customRender: "action" },
        }
      ]
    }
  },
  components: {
    AdminUserForm
  },
  computed: {
    ...mapState(['endPoint']),
  },
  mounted: async function() {
    await this.getAdmins();
  },
  methods: {
    getAdmins: async function() {
      let request = {};
      request = await HTTPRequest.getRequest(`${this.endPoint}admin`, null);
      this.admins = request.admins || [];
    },
    addAdmin: async function() {

    },
    actionPromotion(user, action) {
      if (['create','edit'].includes(action)) {
        this.userFormAction = action;
        this.selectedUser = user;
        this.showUserForm = true;
      }
    },
    closeAdminUserForm() {
      this.userFormAction = 'create';
      this.selectedUser = {};
      this.showUserForm = false;
    },
    userFormSuccess: async function() {
      await this.getAdmins();
      this.closeAdminUserForm();
    }
  }
}
</script>

<style scoped>
.header-cont {
  padding: 10px 30px;
  margin-top: 20px;
}

.header-cont .btn-cont {
  align-items: center;
  display: inline-flex;
  justify-content: right;
}

.cont {
  padding: 10px 30px;
}
</style>
